"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableAction = exports.Table = void 0;
const index_js_1 = require("../errors/index.js");
const isString_js_1 = require("../utils/validation/isString.js");
const constants_js_1 = require("./constants.js");
const constants_js_2 = require("./constants.js");
class Table {
    constructor({ documentClient, name, partitionKey, sortKey, indexes = {}, entityAttributeSavedAs = '_et' }) {
        this.getDocumentClient = () => {
            if (this.documentClient === undefined) {
                throw new index_js_1.DynamoDBToolboxError('actions.missingDocumentClient', {
                    message: 'You need to set a document client on your table to send a command'
                });
            }
            return this.documentClient;
        };
        this.documentClient = documentClient;
        this.name = name;
        this.partitionKey = partitionKey;
        if (sortKey) {
            this.sortKey = sortKey;
        }
        this.indexes = indexes;
        this.entityAttributeSavedAs = entityAttributeSavedAs;
    }
    getName() {
        if (this.name === undefined) {
            throw new index_js_1.DynamoDBToolboxError('table.missingTableName', {
                message: 'Please specify a table name in your Table constructor or in your command options.'
            });
        }
        if ((0, isString_js_1.isString)(this.name)) {
            return this.name;
        }
        else {
            return this.name();
        }
    }
    build(Action) {
        return new Action(this);
    }
}
exports.Table = Table;
class TableAction {
    constructor(table, entities = []) {
        this.table = table;
        this[constants_js_2.$entities] = entities;
    }
}
exports.TableAction = TableAction;
